import { useDispatch } from "react-redux";
import { medications } from "./medications";
import { setMedications } from "../../../../entities/patient-stats/medications/medications.slice";

export const useGetMedications = () => {
  const dispatch = useDispatch();

  const getMedicationsByPatientId = async (patientId: string) => {
    const res = await new Promise((resolve) => {
      setTimeout(() => {
        const filtered = medications.filter(
          (p) => String(p.patientId) === patientId,
        );
        resolve(filtered[0]);
      }, 400);
    }); // имитация API

    dispatch(setMedications(res)); // сохраняем в сторе
  };

  return {
    getMedicationsByPatientId,
  };
};
